import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { CurrentUser } from "../../common/providers/current-user";
import { IsLoggedInGuard, IsLoggedInService } from '../../common/guards/is-logged-in';
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class UsersCanEditUserGuard implements CanActivate {
    constructor(
        private _currentUser: CurrentUser,
        private _isLoggedIn: IsLoggedInService,
        private _router: Router
    ) { }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
      return this._isLoggedIn.runIsLoggedIn(route).pipe(
          map((isLoggedIn: any) => {
              const userId: number | null = this.getUserId(route);
              if (isLoggedIn && this._currentUser.user!.id === userId) {
                  return true;
              } else if (isLoggedIn) {
                  this.redirect();
                  return false;
              } else {
                  return false;
              }
          }),
          catchError((error: any) => {
              this.redirect();
              return of(false);
          })
      );
    }

    private redirect(): void {
        this._router.navigate(['401']);
    }

    private getUserId(route: ActivatedRouteSnapshot): number | null {
        if (route.params["userId"]) {
            return parseInt(route.params['userId'], 10);
        }

        return null;
    }

}
